export default __webpack_public_path__ + "99bb1cc05296014216d244d54c19f0e4.svg";